module.exports = __webpack_public_path__ + "img/Dantam Hair 29.7a333832.jpg";